import { useNavigate } from 'react-router-dom';

// Cabeçalho da página no app (celular): ← + "Para organizadores".
// No computador este some — lá quem manda é o menu normal do site (Topo).
export default function TopoConheca() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 border-b border-background-200/70 bg-background-100/95 backdrop-blur-md md:hidden">
      <div className="mx-auto flex h-14 w-full max-w-[560px] items-center gap-3 px-4">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Voltar"
          className="aperta flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-800 shadow-pcard"
        >
          <i className="ri-arrow-left-line text-xl" aria-hidden />
        </button>
        <h1 className="min-w-0 flex-1 truncate text-[18px] font-extrabold text-foreground-950">
          Para organizadores
        </h1>
      </div>
    </header>
  );
}